import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Gallery from '../components/Gallery';
import About from '../components/About';
import LazyImage from '../components/LazyImage';
import { artistsData } from '../utils/artistsData';

const Home = () => {
  return (
    <>
      <Header />
      
      <main>
      
        <section id="portfolio" className="portfolio-section">
          {artistsData.map((artist, index) => (
            <Gallery 
              key={`artist-${index}`}
              artistName={artist.name}
              images={artist.images}
            />
          ))}
        </section>
        <About />
      </main>
      <Footer />
    </>
  );
};

export default Home;